import _ from 'lodash';
import DashboardRoundedIcon from '@material-ui/icons/DashboardRounded';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import BusinessIcon from '@material-ui/icons/Business';
import ExploreIcon from '@material-ui/icons/Explore';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import BarChartIcon from '@material-ui/icons/BarChart';
import AccessAlarm from '@material-ui/icons/AccessAlarm';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import StorageIcon from '@material-ui/icons/Storage';
import StoreIcon from '@material-ui/icons/Store';
import ScheduleIcon from '@material-ui/icons/Schedule';
import DonutLargeIcon from '@material-ui/icons/DonutLarge';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import GroupIcon from '@material-ui/icons/Group';
import DateRangeIcon from '@material-ui/icons/DateRange';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import PeopleIcon from '@material-ui/icons/People';
import BuildIcon from '@material-ui/icons/Build';
import SportsKabaddiIcon from '@material-ui/icons/SportsKabaddi';
import AssignmentIcon from '@material-ui/icons/Assignment';
import RateReviewIcon from '@material-ui/icons/RateReview';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import CompareArrowsIcon from '@material-ui/icons/CompareArrows';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import AssessmentIcon from '@material-ui/icons/Assessment';
import PieChartIcon from '@material-ui/icons/PieChart';
// import { SettingsCell } from '@material-ui/icons'; // was used by App Content group (E-Info moved to Controller)
import InfoIcon from '@material-ui/icons/Info';
import SettingsIcon from '@material-ui/icons/Settings';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import HistoryIcon from '@material-ui/icons/History';
import VisibilityIcon from '@material-ui/icons/Visibility';
import ListAltIcon from '@material-ui/icons/ListAlt';
import EventNoteIcon from '@material-ui/icons/EventNote';
import RoomIcon from '@material-ui/icons/Room';
import WarningIcon from '@material-ui/icons/Warning';
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';
import AnnouncementIcon from '@material-ui/icons/Announcement';
// import LocalOfferIcon from '@material-ui/icons/LocalOffer'; // used by Promotion group (temporarily hidden)
// import LoyaltyIcon from '@material-ui/icons/Loyalty'; // used by Promotion group (temporarily hidden)

const item = (key, label, icon, route, matchRoutes) => ({
	key,
	label,
	icon,
	route,
	matchRoutes: matchRoutes || [route]
});

const group = (key, label, icon, children) => ({
	key,
	label,
	icon,
	children
});

const filterByAvailable = (arr, availableModules) => {
	if (!_.isArray(availableModules) || availableModules.length === 0) return arr;
	return arr.filter((it) => availableModules.includes(it.label));
};

export const buildMenuConfig = ({
	language,
	gState,
	powerBIConfig,
	defaultPhotoGallery,
	promoterMode,
	merchandiserMode,
	availableModules,
	modules,
	displayReport,
	competitorModule,
	surveyModule,
	surveyResponseModule,
	csrActivityModule,
	itemDistAnalysisReport,
	itemDistAnalysisReportByAgent,
	stockNearExpiryAnalysisByItem,
	stockNearExpiryAnalysisByDayModule,
	oosInsightModule,
	manageUsersModule
}) => {
	const isClient = (c) => gState.client === c;
	const clientInList = (list) => list.includes(gState.client);
	const isLiansin = gState.client && gState.client.includes('liansin');

	const sections = [];
	const tableAnalysisChildren = []; // pulled out of Merchandising/Promoter into one top-level section after Controller

	const dashboardRoute = _.isEmpty(powerBIConfig) ? 'dashboard' : 'powerbiinsight';
	// Dashboard — top-level entry (was a Dashboard group; check-in moved out to its own top-level entry, so no need to nest a single child).
	// Old grouped form kept for reference:
	// const dashboardKids = [item('dashboard', language.dashboard, DashboardRoundedIcon, dashboardRoute, ['dashboard', 'powerbiinsight'])];
	// if (merchandiserMode && filterByAvailable([item('checkin', language.checkin, ExploreIcon, 'checkin')], availableModules).length > 0) {
	// 	dashboardKids.push(item('checkin', language.merchandising_checkin, ExploreIcon, 'checkin'));
	// }
	// if (promoterMode) {
	// 	dashboardKids.push(item('promotercheckin', language.promoter_checkin, ExploreIcon, 'promotercheckin'));
	// }
	// sections.push(group('dashboardgroup', language.dashboard, DashboardRoundedIcon, dashboardKids));
	sections.push(item('dashboard', language.dashboard, DashboardRoundedIcon, dashboardRoute, ['dashboard', 'powerbiinsight']));

	// Check-In — single top-level entry (merchandising + promoter merged; both routes render the same Checkin page).
	const showCheckin =
		(merchandiserMode && filterByAvailable([item('checkin', language.checkin, ExploreIcon, 'checkin')], availableModules).length > 0)
		|| promoterMode;
	if (showCheckin) {
		sections.push(item('checkin', language.checkin, ExploreIcon, 'checkin', ['checkin', 'promotercheckin']));
	}

	if (merchandiserMode) {
		const merchKids = [];

		const merchItems = [
			item('managesched', language.manage_sched, AccessAlarm, 'managesched')
		];
		if (competitorModule) {
			merchItems.push(item('competitor', language.competitor_price_checking, SportsKabaddiIcon, 'competitor'));
		}
		merchKids.push(...filterByAvailable(merchItems, availableModules));

		const insightChildren = [];
		if (!clientInList(['syncly', 'kheesan_csr', 'abaro', 'hlyong'])) {
			insightChildren.push(item('aainsight', language.agent_attend_insight, SupervisorAccountIcon, 'aainsight'));
		}
		if (oosInsightModule) {
			insightChildren.push(item('oosinsight', 'OOS Insight', WarningIcon, 'oosinsight'));
		}
		const filteredInsight = filterByAvailable(insightChildren, availableModules);
		if (filteredInsight.length > 0) {
			merchKids.push(group('insight', language.insight, ShowChartIcon, filteredInsight));
		}

		const reportChildren = [
			item('ragentattend', language.agent_attend, PersonPinIcon, 'ragentattend'),
			item('rstocktake', language.stock_take, StorageIcon, 'rstocktake'),
			item('roos', language.oos, ErrorOutlineIcon, 'roos'),
			item('routletvisit', language.outlet_visit, StoreIcon, 'routletvisit'),
			item('rstocknearexpiry', language.stock_near_expiry, ScheduleIcon, 'rstocknearexpiry'),
			item('gallery', language.photo_gallery, PhotoCameraIcon, defaultPhotoGallery ? 'gallery2' : 'gallery', ['gallery', 'gallery2'])
		];
		if (isClient('serba_promoter') || isClient('brahim_promoter')) {
			reportChildren.push(item('rincentive', language.incentive, CardGiftcardIcon, 'rincentive'));
		}
		reportChildren.push(item('rposm', isLiansin ? language.posm : language.checklist, AssignmentTurnedInIcon, 'rposm'));
		if (displayReport) {
			reportChildren.push(item('rdisplay', 'Display %', VisibilityIcon, 'rdisplay'));
			reportChildren.push(item('rsku', 'SKU %', ListAltIcon, 'rsku'));
		}
		if (competitorModule) {
			reportChildren.push(item('rcompetitorpricecheck', language.rCompetitorPriceCheck, AttachMoneyIcon, 'rcompetitorpricecheck'));
		}
		if (modules && modules.skustandard && modules.skustandard.enabled) {
			reportChildren.push(item('rskustandard', modules.skustandard.title, FormatListNumberedIcon, 'rskustandard'));
		}
		if (surveyResponseModule) {
			reportChildren.push(item('rsurveyresponse', language.survey_response, FiberManualRecordIcon, 'rsurveyresponse'));
		}
		if (csrActivityModule) {
			reportChildren.push(item('csractivity', language.csr_activity, FiberManualRecordIcon, 'csractivity'));
		}
		if (isClient('easymdemo')) {
			reportChildren.push(item('rplacestracking', language.google_location_tracking, RoomIcon, 'rplacestracking'));
		}
		const filteredReport = filterByAvailable(reportChildren, availableModules);
		if (filteredReport.length > 0) {
			merchKids.push(group('merchreport', language.report, AssessmentIcon, filteredReport));
		}

		const analysisChildren = [];
		if (!clientInList(['syncly', 'kheesan_csr', 'abaro'])) {
			analysisChildren.push(item('routletvisitanalysis', language.outlet_visit_merchandising, LocationOnIcon, 'routletvisitanalysis'));
			analysisChildren.push(item('rstocknearexpiryanalysis', language.stock_near_expiry, DateRangeIcon, 'rstocknearexpiryanalysis'));
		}
		if (stockNearExpiryAnalysisByDayModule) {
			analysisChildren.push(item('rstocknearexpiryanalysisbyday', `${language.stock_near_expiry} (By Day)`, CalendarTodayIcon, 'rstocknearexpiryanalysisbyday'));
		}
		if (isClient('easymdemo')) {
			analysisChildren.push(item('rphototakenanalysis', language.photo_taken, CameraAltIcon, 'rphototakenanalysis'));
		}
		if (stockNearExpiryAnalysisByItem) {
			analysisChildren.push(item('rstocknearexpiryanalysisbyitem', language.stock_near_expiry_analysis_by_item, DonutLargeIcon, 'rstocknearexpiryanalysisbyitem'));
		}
		if (competitorModule) {
			analysisChildren.push(item('rcompetitorpricecheckanalysis', language.rCompetitorPriceCheck, CompareArrowsIcon, 'rcompetitorpricecheckanalysis'));
		}
		if (itemDistAnalysisReport) {
			analysisChildren.push(item('ritemdistanalysis', language.item_distribution_analysis, BarChartIcon, 'ritemdistanalysis'));
		}
		if (itemDistAnalysisReportByAgent) {
			analysisChildren.push(item('ritemdistanalysisbyagent', language.item_distribution_analysis_by_agent, GroupIcon, 'ritemdistanalysisbyagent'));
		}
		const filteredAnalysis = filterByAvailable(analysisChildren, availableModules);
		tableAnalysisChildren.push(...filteredAnalysis);

		if (merchKids.length > 0) {
			sections.push(group('merchandising', language.merchandising, HomeWorkIcon, merchKids));
		}
	}

	if (promoterMode) {
		const promoterKids = [];

		const promoterReport = filterByAvailable([
			item('rpromoterattend', language.promoter_attend, PersonPinIcon, 'rpromoterattend'),
			item('rstockcount', language.stock_count, StorageIcon, 'rstockcount'),
			// item('promotergallery', language.photo_gallery, PhotoCameraIcon, defaultPhotoGallery ? 'promotergallery2' : 'promotergallery', ['promotergallery', 'promotergallery2']), // hidden per request — route kept
			item('promoteractivitygallery', language.promoter_photo_category, PhotoCameraIcon, 'promoteractivitygallery')
		], availableModules);
		if (promoterReport.length > 0) {
			promoterKids.push(group('promoterreport', language.report, AssessmentIcon, promoterReport));
		}

		const promoterAnalysis = filterByAvailable([
			item('promoterroutletvisitanalysis', language.outlet_visit_promoter, LocationOnIcon, 'promoterroutletvisitanalysis')
		], availableModules);
		tableAnalysisChildren.push(...promoterAnalysis);

		sections.push(group('promoter', language.promoter, PersonPinIcon, promoterKids));
	}

	const controllerChildren = [
		item('customer', language.customer_low, BusinessIcon, 'customer'),
		item('stocklist', language.stock, CreateNewFolderIcon, 'stocklist'),
		item('stocktemplate', language.stock_template, NoteAddIcon, 'stocktemplate')
	];
	if (merchandiserMode && surveyModule) {
		controllerChildren.push(item('rsurvey', language.survey_form, AssignmentIcon, 'rsurvey'));
	}
	controllerChildren.push(item('appcontent', language.app_content, InfoIcon, 'appcontent'));
	const filteredController = filterByAvailable(controllerChildren, availableModules);
	if (filteredController.length > 0) {
		sections.push(group('controller', language.controller, FormatListBulletedIcon, filteredController));
	}

	// Promotion — top-level (was nested under Promoter). Both Merchandising and Promoter use it, so no mode gate.
	// Temporarily hidden — feature not yet complete. Routes kept; re-enable when done.
	// sections.push(group('promotion', language.promotion, LocalOfferIcon, [
	// 	item('promolist', language.promo_list, ListAltIcon, 'promolist'),
	// 	item('promotiontypes', language.promotion_types, LoyaltyIcon, 'promotiontypes')
	// ]));

	if (tableAnalysisChildren.length > 0) {
		sections.push(group('analysis', language.table_analysis_report, PieChartIcon, tableAnalysisChildren));
	}

	if (isClient('easymdemo')) {
		sections.push(group('announcement', language.announcement, AnnouncementIcon, [
			item('announcement_compose', language.announcement_compose, NoteAddIcon, 'announcement?tab=0', []),
			item('announcement_manage', language.announcement_manage, ListAltIcon, 'announcement?tab=1', [])
		]));
	}

	sections.push(group('feedback', language.feedback, RateReviewIcon, [
		item('feedback_listing', language.feedback_listing, ListAltIcon, 'feedback')
	]));

	if (modules && modules.leaves) {
		sections.push(group('leaves', language.leaves, EventNoteIcon, [
			item('leaves_listing', language.leaves_listing, ListAltIcon, 'leaves')
		]));
	}

	const userMgmt = [item('usersettings', language.user_settings, AccountBoxIcon, 'usersettings')];
	if (manageUsersModule) {
		userMgmt.unshift(item('manageusers', language.user_account, PeopleIcon, 'manageusers'));
	}
	sections.push(group('userManagement', language.user_management, SupervisedUserCircleIcon, userMgmt));

	sections.push(group('audittrail', language.audit_trail, HistoryIcon, [
		item('audittrailoutlet', language.customer_low, BusinessIcon, 'audittrailoutlet')
	]));

	sections.push(group('settings', language.settings, SettingsIcon, [
		item('systemsettings', language.system_settings, BuildIcon, 'systemsettings', ['systemsettings', 'systemsettings2'])
	]));

	sections.push(item('tutorials', language.tutorials, FiberManualRecordIcon, 'tutorials'));

	return sections.filter((s) => !s.children || s.children.length > 0);
};
